// GENERATED FILE - do not edit by hand.
// Source: design-system/semantic.json + primitives.json
// Regenerate: node design-system/generate.mjs

import { colorTokens, semanticTokens, unmappedTokens } from "./colorTokens";

export type SemanticColor = keyof typeof semanticTokens;
export type UnmappedColor = keyof typeof unmappedTokens;
export type ColorName = SemanticColor | UnmappedColor;

export const Colors = colorTokens as Record<ColorName, string>;
